import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Text as l } from "../../atoms/Text/Text.mjs";
import { Icon as n } from "../../atoms/Icon/Icon.mjs";
import { cn as a } from "../../../utils/utils.mjs";
function u({
  previewUrl: r,
  fileName: c,
  onRemove: s,
  className: o,
  disabled: i
}) {
  return /* @__PURE__ */ t("div", { className: a("size-full flex gap-3 justify-between items-center text-black dark:text-white", o), children: [
    /* @__PURE__ */ t("div", { className: "flex min-w-0 items-center gap-3", children: [
      /* @__PURE__ */ e("img", { src: r, alt: "Uploaded image", className: "object-cover w-12 h-12 rounded-sm shrink-0" }),
      /* @__PURE__ */ t("div", { className: "flex flex-col overflow-hidden", children: [
        /* @__PURE__ */ e(l, { fontSize: "sm", className: "truncate", children: c }),
        /* @__PURE__ */ e(l, { fontWeight: "regular", fontSize: "xs", className: "text-black dark:text-neutral-dark-600", children: "Selected image" })
      ] })
    ] }),
    /* @__PURE__ */ e(
      "button",
      {
        type: "button",
        onClick: s,
        className: a("shrink-0", i ? "cursor-not-allowed" : "cursor-pointer"),
        "aria-label": "Remove image",
        title: "Remove image",
        disabled: i,
        children: /* @__PURE__ */ e(
          n,
          {
            name: "close",
            width: 16,
            height: 16,
            className: a("[&_path]:fill-black dark:[&_path]:fill-white")
          }
        )
      }
    )
  ] });
}
export {
  u as ImageFileInputSuccessState
};
